import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, IconButton, Paper, Tooltip, Typography, useMediaQuery, useTheme } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Archive } from 'v2-types/order';
import { FileData } from './components/FileData';

type AutoRowProps = {
  documentId: string,
  locked: boolean,
  description: string,
  archives: Archive[],
  handleDownload: (link: string, fileName: string) => void,
  viewFile: (fileId: string) => void,
  onLockedToggle: (fileId: string, lock: boolean, documentTitle: string) => void,
  onRequestSignature: (fileSource: string) => void
}

export const AutoRow: React.FC<AutoRowProps> = ({ documentId, locked, description, archives, handleDownload, viewFile, onLockedToggle, onRequestSignature }) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Paper elevation={2} key={documentId}>
      <Box
        style={{
          backgroundColor: "#f8fafb",
          minHeight: theme.spacing(6),
          display: "flex",
          alignItems: "center",
          borderBottom: "1px solid lightgray",
          justifyContent: "space-between",
          flexWrap: 'wrap',
          padding: theme.spacing(0.5, 1, 0.5, 3),
          gap: theme.spacing(0.5)
        }}
      >
        <Typography variant="body1" color="primary" style={{ minWidth: 0, overflowWrap: 'anywhere' }}>{description}</Typography>
        <Tooltip title={locked ? t('documents:file-locked-tooltip') : t('documents:file-unlocked-tooltip')}>
          <IconButton
            size="small"
            style={{ padding: isMobile ? theme.spacing(1.5) : undefined, marginLeft: 'auto' }}
            onClick={() => onLockedToggle(documentId, !locked, description)}
          >
            <FontAwesomeIcon icon={locked ? "lock" : "unlock"} />
          </IconButton>
        </Tooltip>
      </Box>
      {archives.length > 0 && (
        <Box style={{ padding: "0rem 1rem 0rem 1rem" }}>
          {archives.map(({ _id, files }) => (
            <Box key={_id}>
              {files && files.length > 0 && files
                .filter(({ data }) => data)
                .map((file) => (
                  <FileData
                    key={file._id}
                    file={file}
                    onRequestSignature={onRequestSignature}
                    handleDownload={handleDownload}
                    viewFile={viewFile}
                    showBorderBottom={archives.length > 1}
                  />
                ))}
            </Box>
          ))}
        </Box>
      )}
    </Paper>
  );
};
